'use client';

import BouncyText from '~/components/molecules/BouncyText';
import { LinkSchema } from '~/lib/api/fragments/link';

interface BouncyLinkProps {
  link: Omit<LinkSchema, 'title'> & {
    title: string | { text: string; className?: string }[];
  };

  className?: string;
}

const BouncyLink: React.FC<BouncyLinkProps> = ({
  link,
  className = 'text-brand-primary text-lg',
}) => (
  <BouncyText
    as="a"
    href={link.url}
    target={link.target}
    className={className}
    text={link.title}
  />
);

export default BouncyLink;
